module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/181.a9ba1b2c.png";